export const INTERVENTION_REPORTS_STATUS_PENDING = 100
export const INTERVENTION_REPORTS_STATUS_IN_PROGRESS = 200
export const INTERVENTION_REPORTS_STATUS_SIGNED = 300
export const INTERVENTION_REPORTS_STATUS_SENT = 400
export const INTERVENTION_REPORTS_STATUS_SIGNED_CUSTOMER = 500
export const INTERVENTION_REPORTS_STATUS_ARCHIVED = 600

export const INTERVENTION_REPORTS_STATUS_LIST = [
  {
    value: INTERVENTION_REPORTS_STATUS_PENDING,
    label: 'En attente',
    color: 'yellow',
    textColor: 'black'
  },
  {
    value: INTERVENTION_REPORTS_STATUS_IN_PROGRESS,
    label: 'En cours',
    color: 'blue'
  },
  {
    value: INTERVENTION_REPORTS_STATUS_SIGNED,
    label: 'Signé par agent',
    color: 'green'
  },
  {
    value: INTERVENTION_REPORTS_STATUS_SENT,
    label: 'Envoyé',
    color: 'green'
  },
  {
    value: INTERVENTION_REPORTS_STATUS_SIGNED_CUSTOMER,
    label: 'Signé par client',
    color: 'green'
  },
  {
    value: INTERVENTION_REPORTS_STATUS_ARCHIVED,
    label: 'Archivé',
    color: 'red'
  }
]

export const INTERVENTION_REPORTS_STATUS = _.keyBy(INTERVENTION_REPORTS_STATUS_LIST, 'value')

/**
 * Liste des status considérés comme actifs
 */
export const INTERVENTION_REPORTS_STATUS_ACTIFS = INTERVENTION_REPORTS_STATUS_LIST.filter((s) => [INTERVENTION_REPORTS_STATUS_ARCHIVED].indexOf(s.value) === -1)

export const INTERVENTION_REPORTS_DEFAULT_TEMPLATE = {
  blocs: [
    {
      col: 12,
      key: 'b5e31f41',
      label: 'Informations',
      fields: [
        {
          key: 'N7AGf4u',
          props: { label: 'Heure d\'appel', required: true },
          fieldType: 'date'
        },
        {
          key: 'N7AH3nt',
          props: {
            label: 'Type d\'intervention',
            options: ['Levée de doute', 'Defaut batterie', 'Maintenance', 'Incendie', 'ABS test', 'Technique', 'Agression', 'ABS mes', 'Ascensseur', 'Defaut secteur', 'MHS non autorisé', 'Autre'],
            multiple: true,
            required: true
          },
          fieldType: 'select'
        },
        { key: '166c802e', props: { label: 'Mauvaise circulation' }, fieldType: 'checkboxInput' }]
    },
    {
      col: 6,
      key: 'b542ef34',
      label: 'Constat météo',
      fields: [
        { key: '77dab445', props: { label: 'Vent' }, fieldType: 'checkbox' }, {
          key: 'b4fe6828',
          props: { label: 'Orage' },
          fieldType: 'checkbox'
        },
        { key: '4d03448f', props: { label: 'Neige' }, fieldType: 'checkbox' }, {
          key: '0759ba6e',
          props: { label: 'Pluie' },
          fieldType: 'checkbox'
        },
        { key: '1150b8cf', props: { label: 'Brouillard' }, fieldType: 'checkbox' }]
    },
    {
      col: 12,
      key: 'af380568',
      label: 'Anomalies',
      fields: [{
        key: '39138854',
        props: { label: 'Vérification intérieur' },
        fieldType: 'checkbox'
      }, {
        key: '5d83ce41',
        props: { label: 'Vérification extérieur' },
        fieldType: 'checkbox'
      }, {
        key: 'e537038e',
        props: { label: 'Lumière allumée', detailLabel: 'Pièce(s)' },
        fieldType: 'checkboxInput'
      }, {
        key: 'da29ec75',
        props: { label: 'Issue(s) ouvertes(s)', detailLabel: 'Lesquelles' },
        fieldType: 'checkboxInput'
      }, { key: 'af61029b', props: { label: 'Sirène en fonction' }, fieldType: 'checkbox' }, {
        key: 'b47c7c93',
        props: { label: 'Système en service' },
        fieldType: 'checkbox'
      }, {
        key: '01811652',
        props: { label: 'Système hors-service à l’arrivée de l’intervenant' },
        fieldType: 'checkbox'
      }, { key: '8f9d0ee0', props: { label: 'Remise en service' }, fieldType: 'checkbox' }, {
        key: '00952df4',
        props: { label: 'Zone(s) en anomalie' },
        fieldType: 'checkbox'
      }, {
        key: '73018d05',
        props: { label: 'Zone(s) isolée(s)' },
        fieldType: 'checkboxInput'
      }, { key: 'cc628431', props: { label: 'Effraction constatée' }, fieldType: 'checkbox' }]
    }, {
      col: 12,
      key: '0e8db546',
      label: 'Mise en place',
      fields: [{
        key: 'bf200c17',
        props: { label: 'ADS', detailLabel: 'Demandé par' },
        fieldType: 'checkboxInput'
      }, {
        key: '13122df7',
        props: { label: 'Maître-chien', detailLabel: 'Préciser' },
        fieldType: 'checkboxInput'
      }]
    },
    {
      col: 12,
      key: '2f93fde8',
      label: 'Présences',
      fields: [{ key: 'ffcb6929', props: { label: 'Police' }, fieldType: 'checkbox' }, {
        key: '1bc981ad',
        props: { label: 'Gendarmerie' },
        fieldType: 'checkbox'
      }, { key: 'c36ade1f', props: { label: 'Pompier' }, fieldType: 'checkbox' }, {
        key: 'a9e49333',
        props: { label: 'Client' },
        fieldType: 'checkbox'
      }, { key: 'f600998c', props: { label: 'Personnel sur place' }, fieldType: 'checkbox' }, {
        key: '878c5ddb',
        props: { label: 'Animaux' },
        fieldType: 'checkbox'
      }, { key: 'df48f8c4', props: { label: 'Véhicule sur place' }, fieldType: 'checkbox' }]
    },
    {
      col: 12,
      key: 'b5e31f4123',
      label: 'Commentaire et Observation',
      fields: [
        {
          key: 'N7AGf4u41',
          props: { label: 'Commentaire' },
          fieldType: 'input'
        }
      ]
    }
  ]
}
